import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { getApiBaseUrlSuffix, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_EXPOSURE_SEARCH_API_URL } from './Constants';

interface Settings extends AGraphApiSettings {
  getConfigurationDirectoryFn?: () => string | undefined;
  getPkgFn?: () => string | undefined;
  getViewAsLogin?: () => string | undefined;
}

export const awExposureSearchSettings: Settings = {};
export const awExposureSearchApi = axios.create();

awExposureSearchApi.interceptors.request.use((config) => {
  const { getConfigurationDirectoryFn, getEnvTypeFn, getPkgFn, getAladdinApiKey, getViewAsLogin } =
    awExposureSearchSettings;
  const configurationDirectory = getConfigurationDirectoryFn ? getConfigurationDirectoryFn() : undefined;
  const viewAs = getViewAsLogin ? getViewAsLogin() : undefined;
  const envType = getEnvTypeFn?.();
  const baseURL = AW_EXPOSURE_SEARCH_API_URL + getApiBaseUrlSuffix(envType, '_', true);

  if (!getPkgFn) {
    throw Error('You must define a function for awExposureSearchSettings.getPkgFn before using this API');
  }
  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      configurationDirectory,
      pkg: config.params?.pkg ?? getPkgFn(),
      viewAs,
    },
  };
  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), envType, 'channel', false);

  return updatedConfig;
});
